import { Pipe, PipeTransform } from '@angular/core';
import { TrackingProvider } from '../../providers/tracking';
import { of } from 'rxjs/observable/of';

@Pipe({
  name: 'match_event'
})
export class MatchEventPipe implements PipeTransform {

  constructor(
    private tracking: TrackingProvider
  ) { }

  transform(idEvent: string, idClient: string): any {
    // return this.tracking.findEntityById(idClient, idEvent, 'event');
    return of();
  }
}



// WEBPACK FOOTER //
// ./src/pipes/event/match-event.ts